// extracted by mini-css-extract-plugin
export default {"button":"styles_button__b7mFL","spinner":"styles_spinner__KKeiY"};